export const defaultPluralMap: Record<string, string> = {
  organisation: 'organisations',
  project: 'projects',
  subsidiary: 'subsidiaries',
  location: 'locations',
  vehicle: 'vehicles',
  supplier: 'suppliers',
  product: 'products',
};

export const defaultSingularMap: Record<string, string> = {
  organisation: 'organisation',
  project: 'project',
  subsidiary: 'subsidiary',
  location: 'location',
  vehicle: 'vehicle',
  supplier: 'supplier',
  product: 'product',
}

export type LabelKey = keyof typeof defaultSingularMap;

export type LabelForm = {
  singular: string;
  plural: string;
};

export interface IScreenLabelsContext {
  getLabel: (
    key: LabelKey,
    options?: { plural?: boolean; capitalize?: 'first' | 'all' }
  ) => string;
  forceUpdateLabels: () => Promise<void>;
}

export interface CustomLabel {
  gaiaTerm: LabelKey;
  customTermSingular: string;
  customTermPlural: string;
}